export default "/images/company2.png?e61cfbe32aa90757b8a77639ce5c3960";